<template>
  <div class="progress-container">
    <div class="row no-gutters" v-for="(stage, index) in stages" :key="index">
      <div class="stage" :class="{ active: currentStage >= stage.number }">
        <div class="circle">{{ stage.number }}</div>
        <div class="label">{{ stage.label }}</div>
      </div>
      <div v-if="index < stages.length - 1" :class="{ active: currentStage > stage.number }" class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Progress",
  props: {
    currentStage: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      stages: [
        {number: 1, label: '選購商品'},
        {number: 2, label: '確認訂單'},
        {number: 3, label: '轉帳匯款'},
        {number: 4, label: '完成訂購'},
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.progress-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 550px;
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .progress-container {
    width: 400px;
  }
}
@media (max-width: 425px) {
  .progress-container {
    width: 300px;
  }
}

.stage {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  //position: relative;
}

.circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #DDE1E9;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 10px;
}

.stage.active .circle {
  background-color: white; /* 当前阶段的白色背景 */
  border: 1px solid #D56835; /* 当前阶段的橘色外框 */
  color: #D56835;
}

.label {
  color: #333333;
  font-size: 14px;
}

.stage.active .label {
  color: #D56835;
}


.line {
  margin: 16px 22px;
  width: 64px;
  height: 1px;
  background-color: #DDE1E9;
  z-index: 0;
}

@media (max-width: 768px) {
  .line {
    margin: 16px 19px;
    width: 20px;
  }
}

@media (max-width: 425px) {
  .line {
    margin: 16px 2px;
  }
}

.line.active {
  background-color: #D56835;
}


.stage:last-child .line {
  display: none;
}
</style>
